// onVisible wires a refresh callback to fire whenever the tab regains focus or
// becomes visible again — so a view that otherwise only polls (or fetched once)
// doesn't sit on stale data after the user switches away and comes back (the
// common "I had to refresh the page" case). Returns a cleanup to call from the
// effect that owns the poll. Debounced so the paired focus + visibilitychange
// events that browsers fire together don't double-trigger.
//
// Usage inside an existing poll effect:
//   useEffect(() => {
//     const id = setInterval(load, 12000);
//     const off = onVisible(load);
//     return () => { clearInterval(id); off(); };
//   }, []);
export function onVisible(fn: () => void): () => void {
  let last = 0;
  const handler = () => {
    if (document.visibilityState !== 'visible') return;
    const now = Date.now();
    if (now - last < 800) return; // collapse the focus + visibilitychange pair
    last = now;
    fn();
  };
  window.addEventListener('focus', handler);
  document.addEventListener('visibilitychange', handler);
  return () => {
    window.removeEventListener('focus', handler);
    document.removeEventListener('visibilitychange', handler);
  };
}
